import styled from '@emotion/styled'
import { CartItemList } from '../Cart'
import { CartType } from '../Cart/Cart'
import { OrderItem } from 'shop/types/cart'

interface Props {
  orderItems: OrderItem[]
  onQuantityChange: (
    orderItem: OrderItem,
    delta: number,
    proceedWithNewOrderItems?: boolean
  ) => Promise<void>
  pendingDeltas: Record<string, number>
}

const ShopCartItemList = ({
  orderItems,
  onQuantityChange,
  pendingDeltas
}: Props) => {
  if (!orderItems.length) return <></>
  return (
    <Items>
      <CartItemList
        items={orderItems}
        type={CartType.Shop}
        onQuantityChange={onQuantityChange}
        pendingDeltas={pendingDeltas}
      />
    </Items>
  )
}

const Items = styled.div(() => ({
  marginBottom: '16px'
}))

export default ShopCartItemList
